module.exports = __webpack_public_path__ + "static/media/calendar.97535e74.svg";